import ufeApi from 'services/api/ufeApi';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Set+Default+Shipping+Address+on+Profile+API

function setDefaultShippingAddress(addressId) {
    const url = '/gway/v2/users/profiles/addresses/defaultAddress';

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify({ addressId })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default setDefaultShippingAddress;
